import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: () =>
      import(/* webpackChunkName: "landing" */ "../views/Index.vue"),
    meta: {
      title: "Argecam SRL",
      layout: "landing-layout"
    }
  },
  {
    path: "/nuestra-empresa",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About/About.vue"),
    meta: {
      title: "Nosotros | Argecam SRL",
      layout: "default-layout"
    }
  },
  {
    path: "/servicios",
    name: "Service",
    component: () =>
      import(/* webpackChunkName: "service" */ "../views/Service/Service.vue"),
    meta: {
      title: "Servicios | Argecam SRL",
      layout: "default-layout"
    }
  },
  {
    path: "/equipos",
    name: "Equipos",
    component: () =>
      import(/* webpackChunkName: "equipos" */ "../views/Equipos/Equipos.vue"),
    meta: {
      title: "Equipos | Argecam SRL",
      layout: "default-layout"
    }
  },
  {
    path: "/nuestros-clientes",
    name: "Clientes",
    component: () =>
      import(
        /* webpackChunkName: "clientes" */ "../views/Clientes/Clientes.vue"
      ),
    meta: {
      title: "Clientes | Argecam SRL",
      layout: "default-layout"
    }
  },
  {
    path: "/nuestras-obras",
    name: "Obras",
    component: () =>
      import(/* webpackChunkName: "obras" */ "../views/Obras/Obras.vue"),
    meta: {
      title: "Obras | Argecam SRL",
      layout: "default-layout"
    }
  },
  {
    path: "/contacto",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact/Contact.vue"),
    meta: {
      title: "Contacto | Argecam SRL",
      layout: "default-layout"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
